import { ConversionRulesLayout } from './layouts';

export function ConversionRulesPage() {
  return <ConversionRulesLayout />;
}
